import React from 'react';
import { Construction } from 'lucide-react';

interface ComingSoonPageProps {
  title: string;
  description?: string;
}

const ComingSoonPage: React.FC<ComingSoonPageProps> = ({ title, description }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border py-24 text-center">
    <Construction className="h-8 w-8 text-muted-foreground" />
    <h2 className="mt-4 text-lg font-semibold text-foreground">{title}</h2>
    <p className="mt-2 max-w-sm text-sm text-muted-foreground">
      {description ?? 'This section of the console is being built and will land in an upcoming update.'}
    </p>
  </div>
);

export default ComingSoonPage;
